module.exports = __webpack_public_path__ + "img/moishop_portfolio_3_mob_2x.8e31303a.png";